module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vpelv2-9fa0cebc5ce98967412723a7ae011be9.jpg";